import React from 'react';
import Axios from 'axios';
import { HashRouter, Route, Switch } from 'react-router-dom';
import NavigationVendor from '../NavigationVendor'
import VendorDashboard from './Dashboard';
import TVPOpportunities from './TerminatedVPOpportunities';
import {checkIfTokenIsPresent} from '../../helper';
import Modal from '../../components/Modal';
import { ROOT_URL } from '../../actions';

function jsonToParam(param, startWith) {
    if (param) {
        let paramArr = [];
        Object.keys(param).forEach(function (key) {
            if (typeof param[key] != 'object')
                paramArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(param[key]));
        });
        return startWith ? startWith + paramArr.join('&') : paramArr.join('&');
    } else {
        return '';
    }
}

class Vendor extends React.Component {

    state={
        displayModal:false,
        conversionTab:false,
        propsForModal:{
            icon: "fas fa-exclamation-circle",
            message: "You do not have permission to access this section.",
            type: "error"
        },
    //     params:{
    //    vendorId:'',
    //     },
        expanded: false,
        defaultOption:this.props.location.pathname,
        options: [
            { icon: "fas fa-users", title: "Overview",link:"/Vendor" },
            { icon: "fas fa-user", title: "Terminated VP Oppurtunities" ,link:"/VendorOpportunities"}]
    }

    handleSelected=(selected)=>{
        console.log(selected);
        if(selected == "Overview") {
            this.props.history.push('/Vendor')
        }
        else if(selected == "Terminated VP Oppurtunities") {
            this.props.history.push('/Vendor/VendorOpportunities')
        }
    }

    handleToggle = (expanded) => {
        this.setState({ expanded })
    }
    componentWillMount(){
        if(!checkIfTokenIsPresent()){
            this.props.history.push('/Login');
       }else{
        
       }
    }
    componentDidMount(){
        if(checkIfTokenIsPresent()){
            this.checkIfPermittedToAccessMember();
        }else{
           // this.props.history.push('/Login');
        }
        // let vendorId = sessionStorage.getItem('vendorId');
        // this.setState({ vendorId: vendorId });
        // Axios.get(ROOT_URL + '/vendor-conversion-opportunity?vendorId=' + (vendorId))
        //     .then(resp => this.setState({ conversionTab: resp.data }));
        
    }
    checkIfPermittedToAccessMember(){
        let groupId = localStorage.getItem('imark-groupId');
        let userType = localStorage.getItem('imark-userType');
        let vendorId = sessionStorage.getItem('imark-vendorId');
        //let vendorId= sessionStorage.vendorId
      //  console.log(vendorId);
       // const groupId = 2;
            if(userType ==="VENDOR" || userType === "CORPORATE" || groupId===1 || groupId===2){
                if(userType==="VENDOR" && !sessionStorage.getItem('imark-vendorId')){
                    this.props.history.push('/');
                }
                this.setState({
                    displayModal:false
                });
            } else{
                this.setState({
                    displayModal:true
                });
            }
    }
    closeModal=()=>{
        this.props.history.push('/');
    }
    render() {
        const {propsForModal} = this.state;
        let modifiedPath = this.props.location.pathname;
        let modifiedPathArr = modifiedPath.split("/");
        modifiedPath = modifiedPathArr[modifiedPathArr.length-1];
        console.log('modified path ',modifiedPath);
        let map = {
            Vendor:"Overview",
            tvpOpportunities:"Terminated VP Oppurtunities",
        }
        modifiedPath = map[modifiedPath];
        console.log('modified path ',modifiedPath);
        if(this.state.displayModal){
            return (
                <div>
               <NavigationVendor isExpanded={this.state.expanded.expanded} />
                <Modal modalType="error" propsForModal={propsForModal} closeModal={this.closeModal} />
                </div>
            )
        }
    
        return (
            <div className="marginBottom">
             <NavigationVendor isExpanded={this.state.expanded.expanded} handleSelected={(selected) => this.handleSelected(selected)} options={this.state.options} defaultOption={modifiedPath}  />
           <HashRouter>
                <Route exact path="/Vendor" render={() => <VendorDashboard isExpanded={this.state.expanded.expanded} />} />
             
                <Route exact path="/Vendor/VendorOpportunities" render={() => <TVPOpportunities isExpanded={this.state.expanded.expanded} />} />
              
                </HashRouter>
       </div>
        )
        }
        
    }

export default Vendor;